import React from 'react'
import '../../../assets/css/rarity-animation.css';

const PlanetDescription = () => {
  return (
    <>
        <section data-bs-version="5.1" className="gallery4 planet-des" id="agallery4-54">
    <div className="container">
        <div className="row">
            <div className="mbr-section-head сol-12" data-aos="fade-up" data-aos-offset="500" data-aos-duration="500">
                <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">Planet Description</h4>
                <h5 className="mbr-section-subtitle align-center mbr-fonts-style mb-0 mt-2 display-4">Empowered by the mystical gemstones, each of the 17 planets in the Bearth Galaxy has flourished in its own unique domain. In a gesture of goodwill, these planets are now willing to lend their gemstones to those eager to visit and learn the local cultures and wisdom they offer. <br />Let us introduce the distinct characteristics of each planet below:</h5>
            </div>

            <div className="col-12 col-items">
                    <div className="item features-image col-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/02-1.webp')} data-slide-to="0" data-bs-slide-to="0" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 2 Planet Foodie</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                A planet with abundant food supply, learn the efficient way to produce food and retrieve the Foodie Stone to solve the food crisis on your planet. 
                            </p>
                            
                        </div>
                    </div>
                </div>
                
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            {/* <img src={require('../../../assets/images/nftscarcity/04.webp')} data-slide-to="1" data-bs-slide-to="1" alt="" /> */}
                             <div class="book">
                                <div class="cover left"></div>
                                <div class="cover right"></div>
                                <div class="page"></div>
                            </div>
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 4 Planet Doctor</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                Due to its natural shape of a book, the planet absorbs the wisdom from the universe. Improve yourself here to retrieve Doctor Stone and use your wisdom to change the reality.
                            </p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <svg className="heart-medical" viewBox="0 0 120 120" aria-label="Medical Heart Icon" role="img">
                                
                                <circle className="pulse-ring" cx="60" cy="60" r="42" fill="#ff3b30"></circle>

                                
                                <path className="heart-shape" fill="#ff3b30" d="
                                M60 98
                                C30 78,16 63,16 44
                                C16 31,26 22,38 22
                                C47 22,53 26,60 35
                                C67 26,73 22,82 22
                                C94 22,104 31,104 44
                                C104 63,90 78,60 98 Z" />

                                
                                <path className="heart-shape" fill="#ff6b5f" opacity="0.25" d="
                                M60 90
                                C35 74,23 61,23 46
                                C23 35,31 28,40 28
                                C47 28,52 31,60 40
                                C68 31,73 28,80 28
                                C89 28,97 35,97 46
                                C97 61,85 74,60 90 Z" />

                                
                                <g className="med-cross" fill="#ffffff">
                                <rect x="54" y="38" width="12" height="28" rx="2" />
                                <rect x="46" y="46" width="28" height="12" rx="2" />
                                </g>
                            </svg>
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 3 Planet Jumpie</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                With state-of-the-art technology in the medical field, Planet Jumpie can teach you how to stay healthy and gives you the Jumpie Stone which contains the secrets to their knowledge.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/14.webp')} data-slide-to="3" data-bs-slide-to="3" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 14 Planet Ocean</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The unique water cube gives the planet a perfect marine ecosystem. Spend time with the ocean life to retrieve the Ocean Stone located in the center of the planet to restore the balance of your ocean.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/tree2.gif')} data-slide-to="4" data-bs-slide-to="4" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 15 Planet Life</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The Life Stone nourishes the soil and nurtures life on land. Learn to appreciate life to retrieve the Life Stone and reverse the damage caused by desertification on your planet.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/16.webp')} data-slide-to="5" data-bs-slide-to="5" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 16 Planet Goodie</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The feather shape of the planet symbolizes peace and justice. Learn how to establish a complete justice system and you will be able to retrieve the Goodie Stone to help you deliver justice.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/09.webp')} data-slide-to="6" data-bs-slide-to="6" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 9 Planet Cycle</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                With the most advanced industrial technology across the universe, you could study the blueprints of the developments here and get help from the Cycle Stone.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            {/* <img src={require('../../../assets/images/nftscarcity/13.webp')} data-slide-to="7" data-bs-slide-to="7" alt="" /> */}
                            <div class="earth">
                                <div class="rotate-wrapper">
                                <div class="land land1"></div>
                                <div class="land land2"></div>
                                <div class="land land3"></div>
                                <div class="shine"></div>
                                </div>
                                <div class="eye left">
                                <div class="pupil"></div>
                                <div class="eyelid"></div>
                                </div>
                                <div class="eye right">
                                <div class="pupil"></div>
                                <div class="eyelid"></div>
                                </div>
                                <div class="smile"></div>
                            </div>
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 13 Planet Beautiful</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The exceptional geological advantages makes the planet perfect for all living forms. Learn every knowledge about climate action here and retrieve the Beautiful Stone to reverse the climate change of your planet.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/17.webp')} data-slide-to="8" data-bs-slide-to="8" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 17 Planet Honey</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The feather shape of the planet symbolizes peace and justice. Learn how to establish a complete justice system and you will be able to retrieve the Goodie Stone to help you deliver justice.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/11.webp')} data-slide-to="9" data-bs-slide-to="9" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 11 Planet Assist</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                Residents on the planet support and care for each other, they design the human settlements and community based on a strong empathy towards one another. The Assist Stone can be retrieved after you study the blueprint of the city development goals and use it to stabilize the society.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/10.webp')} data-slide-to="10" data-bs-slide-to="10" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 10 Planet Happy</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                People from within and among the countries communicate in an equal way. Learn the spirit and you will have the Happy Stone to help you reduce inequality and conflicts on your planet.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/05.webp')} data-slide-to="11" data-bs-slide-to="11" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 5 Planet Colorful</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                Under the influence of the Colorful Stone, people see no difference in each other despite their genders. Once you can see the true color of each other regardless of their gender, you will retrieve the Colorful Stone that will help you remove the barriers which stand between different genders. The colorful outfits from the planet represent the diversity of the society.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/01-1.webp')} data-slide-to="12" data-bs-slide-to="12" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 1 Planet Molly</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                It is the wealthiest and also the most generous planet in the universe. Knowing how to earn and when to give back are the biggest reasons for the planet’s success. Once you find the meaning of giving up something to give back, you will then have the Molly Stone that brings wealthy and meaningful life to your planet.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/07.webp')} data-slide-to="13" data-bs-slide-to="13" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 7 Planet Sunny</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The Sunny Stone generates power that provides electricity for the entire planet. Learn how to efficiently use a sustainable source of energy will get you to the Sunny Stone that you can use to resolve the energy crisis on your planet so civilization can move up to the next level.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/06.webp')} data-slide-to="14" data-bs-slide-to="14" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 6 Planet Clean</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                Under the influence of the Colorful Stone, people see no difference in each other despite their genders. Once you can see the true color of each other regardless of their gender, you will retrieve the Colorful Stone that will help you remove the barriers which stand between different genders. The colorful outfits from the planet represent the diversity of the society.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/08.webp')} data-slide-to="15" data-bs-slide-to="15" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 8 Planet Blockchain</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The Blockchain Stone helps the planet to reach its full potential on blockchain technology, not only does it provide numerous job opportunities but also data management of the entire planet is completely decentralized which means shared responsibility by all citizens. Retrieve the Blockchain Stone and help your planet to a major breakthrough on blockchain technology.</p>
                            
                        </div>
                    </div>
                </div>
                <div className="item features-image сol-12 col-md-4" data-aos="flip-left" data-aos-offset="500" data-aos-duration="500">
                    <div className="item-wrapper">
                        <div className="item-img">
                            <img src={require('../../../assets/images/nftscarcity/12.webp')} data-slide-to="16" data-bs-slide-to="16" alt="" />
                        </div>
                        <div className="item-content">
                            <h5 className="item-title mbr-fonts-style mb-0 display-5">No. 12 Planet Infinity</h5>
                            <p className="mbr-text mbr-fonts-style display-7">
                                The Infinity Stone makes everything possible, its ability to calculate and foresee every outcome allows the planet to always be in balance among all sorts of energy exchange. Master the art of balance and retrieve the Infinity Stone to bring balance back to your planet once again.</p>
                        </div>
                    </div>
                </div>
                {/* <div className="col-12 btb-btn">
                    <a className="btn btn-theme-y display-4" href="#">Back to Bearth</a>
                </div> */}
            </div>
        </div>
    </div>
</section>
    </>
  )
}

export default PlanetDescription